<div class="onboarding-page" *ngIf="isBrowser">
  <div class="page-header text-center">
    <a routerLink="/"><span class="logo logo-white"></span></a>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xs-4 col-md-4 col-lg-4">

        <div class="card shadow-3 rd-3">
          <div class="card-header text-center">
<!--
            <div class="row justify-content-center">
              <app-wizard-navigation [numberOfPages]="2" [currentPage]="1"></app-wizard-navigation>
            </div> -->

            <h3>{{'SHARED.login.login' | translate}}</h3>

          </div>
          <div class="card-body">

            <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form">
              <app-text-input formControlName="email" [submitAttempted]="submitAttempted" placeholder="{{'SHARED.login.emailPlaceholder' | translate}}" inputType="email"
                invalidMsg="{{'SHARED.login.emailInvalidMessage' | translate}}"></app-text-input>
              <app-text-input formControlName="password" [submitAttempted]="submitAttempted" placeholder="{{'SHARED.login.passwordPlaceholder' | translate}}" inputType="password"
                invalidMsg="{{'SHARED.login.passwordInvalidMessage' | translate}}"></app-text-input>
              <app-alert [msg]="errorMsg" type="danger"></app-alert>
              <app-submit-btn inputClasses="w100 btn-lg" btnCopy="{{'SHARED.login.ctaLogin' | translate}}" [loading]="loading" [hasError]="errorMsg"></app-submit-btn>
            </form>
            <div class="fb-login">
              <app-facebook-auth (socialError)="socialError()" type="{{'SHARED.login.ctaLogin' | translate}}"></app-facebook-auth>
            </div>
            <div class="fb-login">
              <app-google-auth (socialError)="socialError()" [showBotton]="true" type="login"></app-google-auth>
            </div>

            <div class="card-caption">
              <p>{{'SHARED.login.passwordNotRemember' | translate}} <a rel="canonical" routerLink="/recoverpass">{{'SHARED.login.clickHere' | translate}}</a></p>
            </div>

          </div>
        </div>
        <p class="footer-links">{{'SHARED.login.notRegisteredYet' | translate}} <a rel="canonical" routerLink="/signup">{{'SHARED.login.signupHere' | translate}}</a></p>

      </div>
    </div>
  </div>

</div>
